import React, { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import "./Counter.css"; // Custom CSS

const counters = [
  { id: 1, endValue: 24000, text: "Successful Clients" },
  { id: 2, endValue: 4620, text: "New Instagram Followers" },
  { id: 3, endValue: 80000, text: "Hours Saved" },
  { id: 4, endValue: 11000, text: "Verified User Reviews" },
];

const Counter = ({ endValue, text }) => {
  const [count, setCount] = useState(0);
  const { ref, inView } = useInView({ triggerOnce: false });

  useEffect(() => {
    if (inView) {
      let start = 0;
      const duration = 2000; // 2 seconds
      const increment = endValue / (duration / 10);

      const interval = setInterval(() => {
        start += increment;
        if (start >= endValue) {
          setCount(endValue);
          clearInterval(interval);
        } else {
          setCount(Math.floor(start));
        }
      }, 10);
      return () => clearInterval(interval);
    } else {
      setCount(0); // Reset counter when out of view
    }
  }, [inView, endValue]);

  return (
    <div ref={ref} className="counter-card">
      <h2>{count.toLocaleString()}</h2>
      <p>{text}</p> {/* Now the text is inside the card */}
    </div>
  );
};

const CounterSection = () => {
  return (
    <div className="container py-5">
      <h2 className="text-center">Client Results</h2>
      <p className="text-center mb-5 mt-2">
        Grow your followers on Instagram with genuinely interested users. Experience high engagement.
        <br /> Gain more customers. Don’t take our word for it, see client results for yourself!
      </p>
      <div className="row">
        {counters.map((item) => (
          <div key={item.id} className="col-lg-3 col-md-6 text-center" id="counter-card">
            <Counter endValue={item.endValue} text={item.text} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CounterSection;
